import ReactQuill from 'react-quill';
import { TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Grid, Typography, Container, Box, Stack, Checkbox} from "@mui/material";
import { Location } from './Location';
import { Images } from './Images';
import { PropertyChecklist } from './PropertyChecklist';

export const SellyouProperty = () => {
	const propertyTypes = ["Condominium", "Commercial", "Apartment", "House", "Land"];
  const subTypes = ["Condotel", "Penthouse", "Studio", "Loft", "Others"];
	const contactFields = [
		{ label: "Last Name", defaultValue: "Manalo", xs: 12 },
		{ label: "First Name", defaultValue: "Juan", xs: 12 },
		{ label: "Mobile Number", defaultValue: "+92255456547", xs: 12 },
		{ label: "Email", defaultValue: "juanmanalo@yahoo.com", xs: 12 },
	];

	const modules = {
		toolbar: [
			['bold', 'italic'],
			[{ 'list': 'ordered' }, { 'list': 'bullet' },],
		],
	}
	return (
		<Box width="100%" height="80%" className="overflowY" color="rgba(0,0,0,0.87)">
			<Container maxWidth="sm" style={{ padding: 16 }} >
				<Typography variant="h6" fontWeight={550} gutterBottom>
					List your Property With Us
				</Typography>
				<Grid container spacing={2}>
					{contactFields.map((field) => (
						<Grid item xs={field.xs} key={field.label}>
							<TextField size='small' fullWidth label={field.label} required disabled InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'error.main', }, }, }} sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff"  }}/>
						</Grid>
					))}
				</Grid>
				<FormControl sx={{ backgroundColor: "rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "0.5rem", mt: "1rem" }} fullWidth>
					<FormLabel sx={{ fontSize: "0.95rem", color: "text.primary", }}>
							I am a
							<Typography component="span" color="error">
									*
							</Typography>
					</FormLabel>
					<RadioGroup row name="ownerTypeRadioGroup">
							<FormControlLabel name="ownerType" disabled control={<Radio sx={{ transform: "scale(0.8)" }} />} label="Property Owner" componentsProps={{ typography: { fontSize: 14 } }}/>
							<FormControlLabel name="ownerType" disabled control={<Radio checked={false} sx={{ transform: "scale(0.8)" }}/> } label="Broker" componentsProps={{ typography: { fontSize: 14 } }}/>
					</RadioGroup>
				</FormControl>
				<FormControl sx={{ backgroundColor: "rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "0.5rem", mt: "1rem" }} fullWidth>
					<FormLabel sx={{ fontSize: "0.95rem", color: "text.primary", }}>
							Offer type
							<Typography component="span" color="error">
									*
							</Typography>
					</FormLabel>
					<RadioGroup row name="ownerTypeRadioGroup">
							<FormControlLabel name="ownerType" disabled control={<Radio sx={{ transform: "scale(0.8)" }} />} label="Sell" componentsProps={{ typography: { fontSize: 14 } }}/>
							<FormControlLabel name="ownerType" disabled control={<Radio checked={false} sx={{ transform: "scale(0.8)" }}/> } label="Rent" componentsProps={{ typography: { fontSize: 14 } }}/>
					</RadioGroup>
				</FormControl>
                <FormControl sx={{ backgroundColor: "rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "0.5rem", mt: "1rem" }} fullWidth>
					<FormLabel sx={{ fontSize: "0.95rem", color: "text.primary", }}> Property type </FormLabel>
					<RadioGroup row name="ownerTypeRadioGroup">
                        {propertyTypes.map((v, k) => (
                            <FormControlLabel key={k} disabled control={<Radio checked={v === "Condominium" && true} sx={{ transform: "scale(0.8)" }}/> } label={v}componentsProps={{ typography: { fontSize: 14 } }}/>
                        ))}
					</RadioGroup>
				</FormControl>
                <FormControl sx={{ backgroundColor: "rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "0.5rem", mt: "1rem" }} fullWidth>
					<FormLabel sx={{ fontSize: "0.95rem", color: "text.primary", }}> Sub Type </FormLabel>
					<RadioGroup row name="ownerTypeRadioGroup">
                        {subTypes.map((v, k) => (
                            <FormControlLabel key={k} disabled control={<Radio checked={v === "Condotel" && true} sx={{ transform: "scale(0.8)" }}/> } label={v}componentsProps={{ typography: { fontSize: 14 } }}/>
                        ))}
					</RadioGroup>
				</FormControl>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Condominium Name</Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Unit No / Floor No.</Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Bedroom</Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Bathroom</Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Floor Area (m²)</Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Stack flexDirection="row">
                    <Stack direction="row" alignItems="center" mt="1rem">
                        <Checkbox name="forClosure" size="small" checked={true} disabled/>
                        <Typography fontSize="14px">For Foreclosure</Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" mt="1rem">
                        <Checkbox name="preSelling" size="small" disabled/>
                        <Typography fontSize="14px">For Pre-Selling</Typography>
                    </Stack>
                </Stack>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Price (&#8369;)<Typography component="span" color="error"> * </Typography></Typography>
                    <TextField size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Stack direction="row" alignItems="center" mt="1rem">
                    <Checkbox name="preSelling" size="small" checked={true} disabled/>
                    <Typography fontSize="14px">Show Price Online</Typography>
                </Stack>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "0.875rem", fontWeight: "700", marginBottom: "0.5rem", }}>Available From<Typography component="span" color="error"> * </Typography></Typography>
                    <TextField type="date" size='small' fullWidth disabled sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
                <Box mt="1rem">
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", }}>Listing Title</Typography>
                    <TextField size='small' fullWidth label="Enter Your Property Title" required disabled InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'error.main', }, }, }} sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}/>
                </Box>
				<Box mt="1rem" sx={{ height: '250px', pb: 8, display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="body1" color="text.primary" sx={{ fontSize: "1rem", fontWeight: "700", marginBottom: "0.5rem", }}>Description</Typography>
					<ReactQuill
						readOnly={true}
						theme="snow"
						style={{ flex: 1, width: '100%', height: "100%", className: "overflowY", backgroundColor: "#fff" }}
						modules={modules}
					/>
				</Box>
				<Location />
				<Images />
				<PropertyChecklist />

			</Container>
		</Box>
	);
};


